import type { CasinoServiceParameters as CasinoParams } from '@swf/generated/types/common/CasinoParams';
import type { CasinoServiceParameters as CasinoPlayerGamesParams } from '@swf/generated/types/common/CasinoPlayerGamesParams';

export interface CasinoWidgetConfig {
  gameService: string;
  params?: CasinoParams | CasinoPlayerGamesParams;
  hideOnLogin?: boolean;
  loggedInOnly?: boolean;
}

export enum RenderNames {
  minBet,
  maxBet,
  returnToPlayer,
  paylines,
  features
}

export * from './races';
